import { isArray } from 'lodash'
import React from 'react'

const Detail: React.FC<{ property: string, value: string | string[] }> = ({ property, value }) => {
    return (
        <>
            <p style={{ margin: '0 0 10px' }}><b>{property}</b></p>
            {
                isArray(value)
                    ? value.map((v, i) => <p key={i} style={{ marginBottom: 0, marginTop: 0 }}>{v}</p>)
                    : <p style={{ marginBottom: 0, marginTop: 0 }}>{value}</p>
            }
        </>
    )
}

export default Detail
